import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "./common.css";

// Custom input component
const CustomInput = forwardRef(({ value, onClick }, ref) => {
  return (
    <input
      ref={ref}
      onClick={onClick}
      value={value}
      readOnly
      className="w-100 form-control fs-12 fw-400"
      placeholder="Select date range"
      style={{ height: "36px" }}
    />
  );
});

const CustomDateRangePicker = ({ onChange, startDate, endDate }) => {
  /*  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null); */

  const handleChange = (dates) => {
    const [start, end] = dates;
    /*  setStartDate(start);
    setEndDate(end); */
    if (onChange) onChange({ start, end });
  };

  // Format the value for display in input
  const getDisplayValue = () => {
    if (startDate && endDate) {
      return `${format(startDate, "dd-MM-yyyy")} - ${format(
        endDate,
        "dd-MM-yyyy"
      )}`;
    } else if (startDate) {
      return `${format(startDate, "dd-MM-yyyy")}`;
    } else {
      return "";
    }
  };

  return (
    <DatePicker
      selected={startDate}
      onChange={handleChange}
      startDate={startDate}
      className="w-100 fs-12 fw-400 py-0"
      endDate={endDate}
      selectsRange
      customInput={<CustomInput value={getDisplayValue()} />}
    />
  );
};

export default CustomDateRangePicker;
